import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class Frui_qppzPage extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { frui_qppzPage,currentFrui_qppz} = this.props.user;
     this.fetchList( frui_qppzPage);
  }

  fetchList = (page,values) => {
    const {getFrui_qppzList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getFrui_qppzList(params);
  }

  getDataSource() {
    const { user } = this.props;
    const { frui_qppzById, frui_qppzList } = user;
    if (!frui_qppzList) return [];
    return frui_qppzList.map(id => frui_qppzById[id]);
  }

  get listProps() {
    const { user,actions } = this.props
    const { getFrui_qppzListPending,frui_qppzTotal,frui_qppzPage } = user
    const { deleteFrui_qppz,chooseCurrentFrui_qppz,frui_qppzModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getFrui_qppzListPending,
      columns:[
        {
          title: "品种名称",
          dataIndex: 'qpName',
          key: 'qpName',
          width: 180,
        },
        {
          title: "品种编号",
          dataIndex: 'qpCode',
          key: 'qpCode',
          width: 180,
        },{
          title:'修改时间',
          dataIndex:'updateTime',
          key:'updateTime',
          width: 100
        }
      ],
      pagination:{
        total:frui_qppzTotal,
        current:frui_qppzPage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentFrui_qppz(record);
          frui_qppzModalChange(true,"updata");
        }else if(item.key == 3){
            deleteFrui_qppz(record.id).then((data) => {
            this.fetchList(frui_qppzPage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { user,actions } = this.props
    const { currentFrui_qppz, frui_qppzModalVisible,frui_qppzPage, frui_qppzModalType,submitFrui_qppzPending } = user

    const { frui_qppzModalChange,submitFrui_qppz } = actions;
    const editItem  = frui_qppzModalType === 'create' ? {} : currentFrui_qppz
    return {
      item: frui_qppzModalType === 'create' ? {} : currentFrui_qppz,
      visible: frui_qppzModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitFrui_qppzPending,
      title: `${
        frui_qppzModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "qpName",
          label: "气瓶品种名称",
          initialValue: editItem.qpName || '',
          widget: Input,
          required: true
        },
        {
          key: "qpCode",
          label: "品种编号",
          initialValue: editItem.qpCode || '',
          widget: Input,
          required: true
        }
      ],
      onOk: data => {
        submitFrui_qppz(Object.assign({},data,{})).then(data=> {
          frui_qppzModalChange(false,"create");
          this.fetchList(frui_qppzPage);
        })
      },
      onCancel() {
        frui_qppzModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,user } = this.props
    const { currentFrui_qppz,frui_qppzPage} = user
    const { frui_qppzModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "loginId",
            widget: Input,
            widgetProps:{
                placeholder:"请输入登录名"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(frui_qppzPage,value)
      },
      onAdd() {
        frui_qppzModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,user } = this.props
    const { currentFrui_qppz,frui_qppzPage} = user
    const { frui_qppzModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ frui_qppzModalChange(true,'create')}
            }
        ]
    }
  }


  //  <CrudFilter {...this.filterProps} />

  render() {
    return (
      <Page inner>
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Frui_qppzPage);


// WEBPACK FOOTER //
// ./src/features/user/Frui_qppzPage.js